// Group Products — border is CSS-only via .product-single-current (set in Liquid)

  // Product media controls
  var mediaControls = document.querySelectorAll('.product-gallery__media-control'),
      galleryNavigation = document.querySelector('.product-gallery--navigation'),
      selectedItem, selectedIndex, targetItem;
  
  var onMediaControlClick = function(event) {
    selectedItem = galleryNavigation.querySelector('[data-product-gallery-selected="true"]');
    selectedIndex = parseInt(selectedItem.dataset.productGalleryThumbnail);
  
    if (event.target.classList.contains('product-gallery__media-control--next')) {
      // Next
      targetItem = galleryNavigation.children[selectedIndex + 1];
  
      if (!targetItem) {
        targetItem = galleryNavigation.children[0];
      }
    } else {
      // Prev
      targetItem = galleryNavigation.children[selectedIndex - 1];
  
      if (!targetItem) {
        targetItem = galleryNavigation.children[galleryNavigation.children.length - 1];
      }
    }
  
    targetItem.click();
  };
  
  if (mediaControls && galleryNavigation) {
    for (var i = 0; i < mediaControls.length; i++) {
      mediaControls[i].addEventListener('click', onMediaControlClick);
    }
  }
  
  
  
  class StickyATC extends HTMLElement {
    constructor() {
      super();
      this.isVisible = false;
      this.variantUpdated = false;
      this.priceElement = null;
      this.buttonElement = null;
      this.loaderElement = null;
      this.observer = null;
    }
  
    connectedCallback() {
      this.priceElement = this.querySelector('[data-product-price]');
      this.buttonElement = this.querySelector('.sticky-atc__button');
      this.loaderElement = this.querySelector('[data-product-atc-loader]');
  
      this.observeVariantUpdates();
  
      this.buttonElement.addEventListener('click', this.onButtonClick.bind(this));
      this._scrollTicking = false;
      window.addEventListener('scroll', this.onScroll.bind(this));
    }
  
    observeVariantUpdates() {
      const variantSelect = document.querySelector('select[data-variants]');
  
      if (variantSelect) {
        window.addEventListener('shopify-variants:switch-variant', (e) => {
          this.updatePrice(e.detail.variant);
          this.dataset.variant = e.detail.variant.id;
        });
      }
    }
  
    onScroll() {
      if (this._scrollTicking) return;
      this._scrollTicking = true;

      requestAnimationFrame(() => {
        let stickyHeight = this.offsetHeight;
        let scrollY = window.scrollY + window.innerHeight - stickyHeight;
        const mainProductButton = document.querySelector('.product-details__add-to-cart-buttons .product-details__add-to-cart-button');
        let mainProductButtonOffset = mainProductButton.offsetTop - 10;

        if (scrollY > mainProductButtonOffset) {
          this.hide();
        } else {
          this.show();
        }

        this._scrollTicking = false;
      });
    }
  
    async onButtonClick() {
      this.buttonElement.classList.add('product-details__add-to-cart-button--loading');
      try {
        var response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: this.dataset.variant,
            quantity: 1,
          }),
        });
        if (!response.ok) {
          var error = await response.json();
          throw new Error(error.description || 'Could not add item to cart');
        }
        window.Shopify.getCart(function (cart) {
          var cartAmountWrap = document.querySelector('[data-header-cart-count]');
          cartAmountWrap.textContent = "(".concat(cart.item_count, ")");
        });
      } catch (err) {
        var atcButton = this.buttonElement;
        atcButton.textContent = err.message;
        setTimeout(function () {
          atcButton.textContent = 'Add to Cart';
        }, 3000);
      } finally {
        this.buttonElement.classList.remove('product-details__add-to-cart-button--loading');
      }
    }
  
  
    show() {
      this.classList.add('sticky-atc--visible');
    }
  
    hide() {
      this.classList.remove('sticky-atc--visible');
    }
  
    updatePrice(variant) {
      let { price, compare_at_price } = variant;
      this.priceElement.textContent = window.Shopify.formatMoney(price, Shopify.money_format);
    }
  }
  
  customElements.define('sticky-atc', StickyATC);

  // Sticky header — toggle compact mode on desktop when scrolled past header
  (function() {
    var body = document.body;
    var docEl = document.documentElement;
    var ticking = false;

    function isDesktop() {
      return window.matchMedia('(min-width: 960px)').matches;
    }

    function getAnnouncementHeight() {
      var announcement = document.querySelector('.pxs-announcement-bar');
      return announcement ? announcement.offsetHeight : 0;
    }

    function shouldShowCompactHeader() {
      var siteHeaderWrapper = document.querySelector('.site-header__wrapper');
      var announcementHeight = getAnnouncementHeight();

      if (!isDesktop() || !siteHeaderWrapper) {
        return false;
      }

      return siteHeaderWrapper.getBoundingClientRect().bottom <= announcementHeight;
    }

    function getHeaderControlsHeight() {
      var controls = document.querySelector('[data-header-controls]');
      return controls ? controls.offsetHeight : 0;
    }

    function syncStickyHeaderState() {
      docEl.style.setProperty('--announcement-bar-height', getAnnouncementHeight() + 'px');
      docEl.style.setProperty('--header-controls-height', getHeaderControlsHeight() + 'px');

      if (shouldShowCompactHeader()) {
        body.classList.add('header-scrolled');
      } else {
        body.classList.remove('header-scrolled');
      }
    }

    function onScrollOrResize() {
      if (ticking) return;
      ticking = true;

      requestAnimationFrame(function() {
        syncStickyHeaderState();
        ticking = false;
      });
    }

    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize);
    window.addEventListener('load', onScrollOrResize);
    document.addEventListener('shopify:section:load', onScrollOrResize);
    document.addEventListener('shopify:section:reorder', onScrollOrResize);

    syncStickyHeaderState();
  })();

  // Size option buttons — keep sold-out variants selectable.
  (function() {
    function enableSoldOutSizes() {
      document.querySelectorAll('[data-back-in-stock-sizes] input[data-soldout="true"]').forEach(function(radio) {
        radio.disabled = false;
      });
    }

    enableSoldOutSizes();

    window.addEventListener('shopify-variants:switch-variant', enableSoldOutSizes);
  })();
